import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//成绩管理系统相关API

const scoreManage = {
    //成绩设置
    setting: {
        //默认设置
        defaultConfig: {
            query: config => createAPI('/scoreManage/setting/defaultConfig/query', 'post', config),

            save: config => createAPI('/scoreManage/setting/defaultConfig/save', 'post', config),
        },
        //登分时间设置
        time: {
            initCombo: config => createAPI('/scoreManage/setting/time/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManage/setting/time/queryList', 'post', config),

            saveTime: config => createAPI('/scoreManage/setting/time/saveTime', 'post', config),

            saveBkTime: config => createAPI('/scoreManage/setting/time/saveBkTime', 'post', config),

            saveDbkTime: config => createAPI('/scoreManage/setting/time/saveDbkTime', 'post', config),
        },
        //科目设置
        subject: {
            queryList: config => createAPI('/scoreManage/setting/subject/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManage/setting/subject/initCombo', 'post', config),

            updateSubjectInfo: config => createAPI('/scoreManage/setting/subject/updateSubjectInfo', 'post', config),

            scoreDefaultConfig: config => createAPI('/scoreManage/setting/subject/scoreDefaultConfig', 'post', config),

            loadDfConfig: config => createAPI('/scoreManage/setting/subject/loadDfConfig', 'post', config),

            saveScoreSet: config => createAPI('/scoreManage/setting/subject/saveScoreSet', 'post', config),

            importScoreConfig: config => createAPI('/scoreManage/setting/subject/importScoreConfig', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManage/setting/subject/loadCourseCombo', 'post', config),

            loadClassTree: config => createAPI('/scoreManage/setting/subject/loadClassTree', 'post', config),

            saveScoreBatchSet: config => createAPI('/scoreManage/setting/subject/saveScoreBatchSet', 'post', config),
        },
        //登分人员设置
        person: {
            queryList: config => createAPI('/scoreManage/setting/person/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManage/setting/person/initCombo', 'post', config),

            queryTeaList: config => createAPI('/scoreManage/setting/person/queryTeaList', 'post', config),

            queryTeaStuList: config => createAPI('/scoreManage/setting/person/queryTeaStuList', 'post', config),

            saveTea: config => createAPI('/scoreManage/setting/person/saveTea', 'post', config),

            queryStuList: config => createAPI('/scoreManage/setting/person/queryStuList', 'post', config),

            queryClassStuTree: config => createAPI('/scoreManage/setting/person/queryClassStuTree', 'post', config),

            saveAddStu: config => createAPI('/scoreManage/setting/person/saveAddStu', 'post', config),

            saveStu: config => createAPI('/scoreManage/setting/person/saveStu', 'post', config),

            queryDelStuList: config => createAPI('/scoreManage/setting/person/queryDelStuList', 'post', config),

            delStu: config => createAPI('/scoreManage/setting/person/delStu', 'post', config),

            queryClassCourseList: config => createAPI('/scoreManage/setting/person/queryClassCourseList', 'post', config),

            syncStuList: config => createAPI('/scoreManage/setting/person/syncStuList', 'post', config),

            saveTeaStu: config => createAPI('/scoreManage/setting/person/saveTeaStu', 'post', config),

            addStuScoreData: config => createAPI('/scoreManage/setting/person/addStuScoreData', 'post', config),

            queryTeaAuthList: config => createAPI('/scoreManage/setting/person/queryTeaAuthList', 'post', config),

            saveTeaAuth: config => createAPI('/scoreManage/setting/person/saveTeaAuth', 'post', config),

            delTeaAuth: config => createAPI('/scoreManage/setting/person/delTeaAuth', 'post', config),
        },
        //补考教师设置
        resitTeacher: {
            initCombo: config => createAPI('/scoreManage/setting/resitTeacher/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManage/setting/resitTeacher/queryList', 'post', config),

            queryTeaList: config => createAPI('/scoreManage/setting/resitTeacher/queryTeaList', 'post', config),

            saveTea: config => createAPI('/scoreManage/setting/resitTeacher/saveTea', 'post', config),

            initBkCourseInfo: config => createAPI('/scoreManage/setting/resitTeacher/initBkCourseInfo ', 'post', config),
        },
        //大补考教师设置
        finalResitTeacher: {
            queryList: config => createAPI('/scoreManage/setting/finalResitTeacher/queryList', 'post', config),

            initData: config => createAPI('/scoreManage/setting/finalResitTeacher/initData', 'post', config),

            queryTeaList: config => createAPI('/scoreManage/setting/finalResitTeacher/queryTeaList', 'post', config),

            saveTea: config => createAPI('/scoreManage/setting/finalResitTeacher/saveTea', 'post', config),
        },
        //免修设置
        exemptStudy: {
            queryList: config => createAPI('/scoreManage/setting/exemptStudy/queryList', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManage/setting/exemptStudy/loadCourseCombo', 'post', config),

            loadStuMxmd: config => createAPI('/scoreManage/setting/exemptStudy/loadStuMxmd', 'post', config),

            queStuList: config => createAPI('/scoreManage/setting/exemptStudy/queStuList', 'post', config),

            saveMxStu: config => createAPI('/scoreManage/setting/exemptStudy/saveMxStu', 'post', config),

            loadStuCourseListData: config => createAPI('/scoreManage/setting/exemptStudy/loadStuCourseListData', 'post', config),

            saveStuMxCourse: config => createAPI('/scoreManage/setting/exemptStudy/saveStuMxCourse', 'post', config),

            initCombo: config => createAPI('/scoreManage/setting/exemptStudy/initCombo', 'post', config),
        },
        //缓考成绩设置
        delay: {
            initCombo: config => createAPI('/scoreManage/setting/delay/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManage/setting/delay/queryList', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManage/setting/delay/loadCourseCombo', 'post', config),

            loadStuCourseListData: config => createAPI('/scoreManage/setting/delay/loadStuCourseListData', 'post', config),

            loadStuHkmd: config => createAPI('/scoreManage/setting/delay/loadStuHkmd', 'post', config),

            queStuList: config => createAPI('/scoreManage/setting/delay/queStuList', 'post', config),

            saveHkStu: config => createAPI('/scoreManage/setting/delay/saveHkStu', 'post', config),

            saveStuHkCourse: config => createAPI('/scoreManage/setting/delay/saveStuHkCourse', 'post', config),
        }
    },

    //成绩查询与统计
    query: {
        //整班成绩查询
        classScoreInfo: {
            queryList: config => createAPI('/scoreManage/query/classScoreInfo/queryList', 'post', config),

            initData: config => createAPI('/scoreManage/query/classScoreInfo/initData', 'post', config),

            initStuScoreInfo: config => createAPI('/scoreManage/query/classScoreInfo/initStuScoreInfo', 'post', config),

            exportScoreInfo: config => createAPI('/scoreManage/query/classScoreInfo/exportScoreInfo', 'post', config),

            batchExport: config => createAPI('/scoreManage/query/classScoreInfo/batchExport', 'post', config),
        },
        //学年学期成绩查询
        semesterScore: {
            queryList: config => createAPI('/scoreManage/query/semesterScore/queryList', 'post', config),

            initData: config => createAPI('/scoreManage/query/semesterScore/initData', 'post', config),

            saveSet: config => createAPI('/scoreManage/query/semesterScore/saveSet', 'post', config),

            loadStuScoreInfo: config => createAPI('/scoreManage/query/semesterScore/loadStuScoreInfo', 'post', config),

            exportScoreInfo: config => createAPI('/scoreManage/query/semesterScore/exportScoreInfo', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManage/query/semesterScore/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManage/query/semesterScore/batchExport', 'post', config),

            batchScoreExport: config => createAPI('/scoreManage/query/semesterScore/batchScoreExport', 'post', config),

            batchWarnExport: config => createAPI('/scoreManage/query/semesterScore/batchWarnExport', 'post', config),

            initExCombo: config => createAPI('/scoreManage/query/semesterScore/initExCombo', 'post', config),
        },
        //不合格科目查询
        failSubject: {
            queryList: config => createAPI('/scoreManage/query/failSubject/queryList', 'post', config),

            initData: config => createAPI('/scoreManage/query/failSubject/initData', 'post', config),

            queryExamineList: config => createAPI('/scoreManage/query/failSubject/queryExamineList', 'post', config),

            exportSingle: config => createAPI('/scoreManage/query/failSubject/exportSingle', 'post', config),

            exportBatch: config => createAPI('/scoreManage/query/failSubject/exportBatch', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManage/query/failSubject/loadExportClassCombo', 'post', config),

            loadExportMajorCombo: config => createAPI('/scoreManage/query/failSubject/loadExportMajorCombo', 'post', config),
        },
        //学生成绩单
        stuScoreList: {
            queryList: config => createAPI('/scoreManage/query/stuScoreList/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManage/query/stuScoreList/initCombo', 'post', config),

            queryStuScoreInfo: config => createAPI('/scoreManage/query/stuScoreList/queryStuScoreInfo', 'post', config),

            exportSingle: config => createAPI('/scoreManage/query/stuScoreList/exportSingle', 'post', config),

            exportBatch: config => createAPI('/scoreManage/query/stuScoreList/exportBatch', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManage/query/stuScoreList/loadExportClassCombo', 'post', config),
        },
        //补考名单
        resitStuList: {
            queryList: config => createAPI('/scoreManage/query/resitStuList/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManage/query/resitStuList/initCombo', 'post', config),

            loadStuScoreInfo: config => createAPI('/scoreManage/query/resitStuList/loadStuScoreInfo', 'post', config),

            singleExport: config => createAPI('/scoreManage/query/resitStuList/singleExport', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManage/query/resitStuList/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManage/query/resitStuList/batchExport', 'post', config),

            classListExport: config => createAPI('/scoreManage/query/resitStuList/classListExport', 'post', config),
        },
        //留级名单
        repeatGradeStuList: {
            queryList: config => createAPI('/scoreManage/query/repeatGradeStuList/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManage/query/repeatGradeStuList/initCombo', 'post', config),

            loadScoreInfo: config => createAPI('/scoreManage/query/repeatGradeStuList/loadScoreInfo', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManage/query/repeatGradeStuList/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManage/query/repeatGradeStuList/batchExport', 'post', config),
        },
        //大补考名单
        finalResitStuList: {
            queryList: config => createAPI('/scoreManage/query/finalResitStuList/queryList', 'post', config),

            initData: config => createAPI('/scoreManage/query/finalResitStuList/initData', 'post', config),

            queryStuList: config => createAPI('/scoreManage/query/finalResitStuList/queryStuList', 'post', config),

            singleExport: config => createAPI('/scoreManage/query/finalResitStuList/singleExport', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManage/query/finalResitStuList/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManage/query/finalResitStuList/batchExport', 'post', config),
        },
        //成绩排名
        scoreRank: {
            queryList: config => createAPI('/scoreManage/query/scoreRank/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManage/query/scoreRank/initCombo', 'post', config),

            exportFile: config => createAPI('/scoreManage/query/scoreRank/exportFile', 'post', config),

            printFile: config => createAPI('/scoreManage/query/scoreRank/printFile', 'post', config),
        },
    },

    //特殊成绩申请
    specialScoreApply: {
        initCombo: config => createAPI('/scoreManage/specialScoreApply/initCombo', 'post', config),

        list: config => createAPI('/scoreManage/specialScoreApply/list', 'post', config),

        loadCourseCombo: config => createAPI('/scoreManage/specialScoreApply/loadCourseCombo', 'post', config),

        save: config => createAPI('/scoreManage/specialScoreApply/save', 'post', config),

        submit: config => createAPI('/scoreManage/specialScoreApply/submit', 'post', config),

        updateAuditState: config => createAPI('/scoreManage/specialScoreApply/updateAuditState', 'post', config),

        del: config => createAPI('/scoreManage/specialScoreApply/del', 'post', config),

        attachmentList: config => createAPI('/scoreManage/specialScoreApply/attachmentList', 'post', config),

        uploadMultiFile: config => createAPI('/scoreManage/specialScoreApply/uploadMultiFile', 'post', config),

        delFileById: config => createAPI('/scoreManage/specialScoreApply/delFileById', 'post', config),

        delFileByCode: config => createAPI('/scoreManage/specialScoreApply/delFileByCode', 'post', config),

        queryAuditFlow: config => createAPI('/scoreManage/specialScoreApply/queryAuditFlow', 'post', config),
    },

    //学生个人成绩查询
    stuPersonalScore: {
        initCombo: config => createAPI('/scoreManage/stuPersonalScore/initCombo', 'post', config),

        list: config => createAPI('/scoreManage/stuPersonalScore/list', 'post', config),
    },

    //毕业设计
    graduateDesign: {
        initCombo: config => createAPI('/scoreManage/graduateDesign/initCombo', 'post', config),

        list: config => createAPI('/scoreManage/graduateDesign/list', 'post', config),

        saveRec: config => createAPI('/scoreManage/graduateDesign/saveRec', 'post', config),

        delRec: config => createAPI('/scoreManage/graduateDesign/delRec', 'post', config),

        updateAuditState: config => createAPI('/scoreManage/graduateDesign/updateAuditState', 'post', config),

        attachmentList: config => createAPI('/scoreManage/graduateDesign/attachmentList', 'post', config),

        uploadMultiFile: config => createAPI('/scoreManage/graduateDesign/uploadMultiFile', 'post', config),

        delFile: config => createAPI('/scoreManage/graduateDesign/delFile', 'post', config),
    },
    //毕业设计
    graduateDesign2: {
        initCombo: config => createAPI('/scoreManage/GradeDesign/initCombo', 'post', config),

        list: config => createAPI('/scoreManage/GradeDesign/list', 'post', config),

        listTeacher: config => createAPI('/scoreManage/GradeDesign/listTeacher', 'post', config),

        saveTeacherRec: config => createAPI('/scoreManage/GradeDesign/saveTeacherRec', 'post', config),

        saveRec: config => createAPI('/scoreManage/GradeDesign/saveRec', 'post', config),

        queryRec: config => createAPI('/scoreManage/GradeDesign/queryRec', 'post', config),

        downloadRec: config => createAPI('/scoreManage/GradeDesign/downloadRec', 'post', config),

        queryOption: config => createAPI('/scoreManage/GradeDesign/queryOption', 'post', config),

        queryOption2: config => createAPI('/scoreManage/GradeDesign/queryOption2', 'post', config),

        saveOption: config => createAPI('/scoreManage/GradeDesign/saveOption', 'post', config),

        save: config => createAPI('/scoreManage/GradeDesign/save', 'post', config),
    },
    //竞赛设置
    competition: {

        initCombo: config => createAPI('/scoreManage/competition/initCombo', 'post', config),

        initRegistrationCombo: config => createAPI('/scoreManage/competition/initRegistrationCombo', 'post', config),

        save: config => createAPI('/scoreManage/competition/save', 'post', config),

        saveCompetitionRegistration: config => createAPI('/scoreManage/competition/saveCompetitionRegistration', 'post', config),

        deleteCompetitionRegistration: config => createAPI('/scoreManage/competition/deleteCompetitionRegistration', 'post', config),

        queryList: config => createAPI('/scoreManage/competition/queryList', 'post', config),

        queryListCompetitionRegistration: config => createAPI('/scoreManage/competition/CompetitionRegistration', 'post', config),

        exportCompetitionRegistration: config => createAPI('/scoreManage/competition/exportCompetitionRegistration', 'post', config),

        saveRec: config => createAPI('/scoreManage/competition/saveRec', 'post', config),

        queryRscList: config => createAPI('/scoreManage/competition/queryRscList', 'post', config),

        deletefile: config => createAPI('/scoreManage/competition/deletefile', 'post', config),

    },
    //教学成果
    achievement: {

        initCombo: config => createAPI('/scoreManage/achievement/initCombo', 'post', config),

        initRegistrationCombo: config => createAPI('/scoreManage/achievement/initRegistrationCombo', 'post', config),

        save: config => createAPI('/scoreManage/achievement/save', 'post', config),

        saveCompetitionRegistration: config => createAPI('/scoreManage/achievement/saveCompetitionRegistration', 'post', config),

        deleteAchievementRegistration: config => createAPI('/scoreManage/achievement/deleteAchievementRegistration', 'post', config),

        queryList: config => createAPI('/scoreManage/achievement/queryList', 'post', config),

        updateAchievement: config => createAPI('/scoreManage/achievement/updateAchievement', 'post', config),

        queryListAchievementRegistration: config => createAPI('/scoreManage/achievement/AchievementRegistration', 'post', config),

        exportCompetitionRegistration: config => createAPI('/scoreManage/achievement/exportCompetitionRegistration', 'post', config),

        saveRec: config => createAPI('/scoreManage/achievement/saveRec', 'post', config),

        queryRscList: config => createAPI('/scoreManage/achievement/queryRscList', 'post', config),

        deletefile: config => createAPI('/scoreManage/achievement/deletefile', 'post', config),


    },
    //重修
    retake: {
        initCombo: config => createAPI('/scoreManage/retake/initCombo', 'post', config),

        semesterList: config => createAPI('/scoreManage/retake/semesterList', 'post', config),

        saveDate: config => createAPI('/scoreManage/retake/saveDate', 'post', config),

        initStuListCombo: config => createAPI('/scoreManage/retake/initStuListCombo', 'post', config),

        studentList: config => createAPI('/scoreManage/retake/studentList', 'post', config),

        exportStudentRec: config => createAPI('/scoreManage/retake/exportStudentRec', 'post', config),

        courseList: config => createAPI('/scoreManage/retake/courseList', 'post', config),

        exportCourseRec: config => createAPI('/scoreManage/retake/exportCourseRec', 'post', config),

        queryApplySemester: config => createAPI('/scoreManage/retake/queryApplySemester', 'post', config),

        initApplyCombo: config => createAPI('/scoreManage/retake/initApplyCombo', 'post', config),

        applyList: config => createAPI('/scoreManage/retake/applyList', 'post', config),

        queryApplyCourseCombo: config => createAPI('/scoreManage/retake/queryApplyCourseCombo', 'post', config),

        apply: config => createAPI('/scoreManage/retake/apply', 'post', config),

        exemptApply: config => createAPI('/scoreManage/retake/exemptApply', 'post', config),

        initQueryCombo: config => createAPI('/scoreManage/retake/initQueryCombo', 'post', config),

        studentRetakeList: config => createAPI('/scoreManage/retake/studentRetakeList', 'post', config),

        exportStudentRetakeRec: config => createAPI('/scoreManage/retake/exportStudentRetakeRec', 'post', config),

        checkApplyOpenState: config => createAPI('/scoreManage/retake/checkApplyOpenState', 'post', config),

        delApply: config => createAPI('/scoreManage/retake/delApply', 'post', config),

        stuRepairSettingList: config => createAPI('/scoreManage/retake/stuRepairSettingList', 'post', config),

        handleStuRepairSetting: config => createAPI('/scoreManage/retake/handleStuRepairSetting', 'post', config),
    },

    //历史成绩查询
    historyScoreQuery: {
        initCombo: config => createAPI('/scoreManage/historyScore/initCombo', 'post', config),

        scoreList: config => createAPI('/scoreManage/historyScore/scoreList', 'post', config),
    },

    //统计
    statistics: {
        //成绩登记表
        subjectScoreReport: {
            query: config => createAPI('/scoreManage/statistics/subjectScoreReport/query', 'post', config),

            export: config => createAPI('/scoreManage/statistics/subjectScoreReport/export', 'post', config),

            print: config => createAPI('/scoreManage/statistics/subjectScoreReport/print', 'post', config),
        },

        //试卷质量分析报告
        examQualityAnalysis: {
            initCombo: config => createAPI('/scoreManage/statistics/examQualityAnalysis/initCombo', 'post', config),

            list: config => createAPI('/scoreManage/statistics/examQualityAnalysis/list', 'post', config),

            query: config => createAPI('/scoreManage/statistics/examQualityAnalysis/query', 'post', config),

            export: config => createAPI('/scoreManage/statistics/examQualityAnalysis/export', 'post', config),

            print: config => createAPI('/scoreManage/statistics/examQualityAnalysis/print', 'post', config),

            save: config => createAPI('/scoreManage/statistics/examQualityAnalysis/save', 'post', config),
        },

        //绩点统计
        pointStatistics: {
            queryList: config => createAPI('/scoreManage/statistics/pointStatistics/queryList', 'post', config),

            initData: config => createAPI('/scoreManage/statistics/pointStatistics/initData', 'post', config),

            queryPointList: config => createAPI('/scoreManage/statistics/pointStatistics/queryPointList', 'post', config),

            exportFile: config => createAPI('/scoreManage/statistics/pointStatistics/exportFile', 'post', config),

            printFile: config => createAPI('/scoreManage/statistics/pointStatistics/printFile', 'post', config),
        },

        //学期成绩统计
        semesterScoreStatistics: {
            queryList: config => createAPI('/scoreManage/statistics/semesterScoreStatistics/queryList', 'post', config),

            initData: config => createAPI('/scoreManage/statistics/semesterScoreStatistics/initData', 'post', config),

            loadStatisticsInfo: config => createAPI('/scoreManage/statistics/semesterScoreStatistics/loadStatisticsInfo', 'post', config),

            exportFile: config => createAPI('/scoreManage/statistics/semesterScoreStatistics/exportFile', 'post', config),

            batchExport: config => createAPI('/scoreManage/statistics/semesterScoreStatistics/batchExport', 'post', config),

            loadBatchExportClassCombo: config => createAPI('/scoreManage/statistics/semesterScoreStatistics/loadBatchExportClassCombo ', 'post', config),
        },
    },

    //登记
    register: {
        //班级学期成绩登记
        classSemesterScore: {
            initData: config => createAPI('/scoreManage/register/classSemesterScore/initData', 'post', config),

            loadMajorCombo: config => createAPI('/scoreManage/register/classSemesterScore/loadMajorCombo', 'post', config),

            loadClassCombo: config => createAPI('/scoreManage/register/classSemesterScore/loadClassCombo', 'post', config),

            queryList: config => createAPI('/scoreManage/register/classSemesterScore/queryList', 'post', config),

            loadClassCourseInfo: config => createAPI('/scoreManage/register/classSemesterScore/loadClassCourseInfo', 'post', config),

            loadDfConfig: config => createAPI('/scoreManage/register/classSemesterScore/loadDfConfig', 'post', config),

            loadScoreConvertConfig: config => createAPI('/scoreManage/register/classSemesterScore/loadScoreConvertConfig', 'post', config),

            loadStuList: config => createAPI('/scoreManage/register/classSemesterScore/loadStuList', 'post', config),

            loadLockState: config => createAPI('/scoreManage/register/classSemesterScore/loadLockState', 'post', config),

            saveScoreSet: config => createAPI('/scoreManage/register/classSemesterScore/saveScoreSet', 'post', config),

            saveStuScore: config => createAPI('/scoreManage/register/classSemesterScore/saveStuScore', 'post', config),

            submitStuScore: config => createAPI('/scoreManage/register/classSemesterScore/submitStuScore', 'post', config),

            exportFile: config => createAPI('/scoreManage/register/classSemesterScore/exportFile', 'post', config),

            importFile: config => createAPI('/scoreManage/register/classSemesterScore/importFile', 'post', config),

            loadExemptStuList: config => createAPI('/scoreManage/register/classSemesterScore/loadExemptStuList', 'post', config),

            updateExemptStuScore: config => createAPI('/scoreManage/register/classSemesterScore/updateExemptStuScore', 'post', config),
        },
        //缓考成绩登记
        delayScore: {
            initData: config => createAPI('/scoreManage/register/delayScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManage/register/delayScore/queryList', 'post', config),

            loadClassCourseTreeByScoreType: config => createAPI('/scoreManage/register/delayScore/loadClassCourseTreeByScoreType', 'post', config),

            loadDfConfig: config => createAPI('/scoreManage/register/delayScore/loadDfConfig', 'post', config),

            loadStuListByScoreType: config => createAPI('/scoreManage/register/delayScore/loadStuListByScoreType', 'post', config),

            loadLockState: config => createAPI('/scoreManage/register/delayScore/loadLockState', 'post', config),

            saveStuScore: config => createAPI('/scoreManage/register/delayScore/saveStuScore', 'post', config),

            queryDelayScoreRecordList: config => createAPI('/scoreManage/register/delayScore/queryDelayScoreRecordList', 'post', config),

            exportDelayScoreRecord: config => createAPI('/scoreManage/register/delayScore/exportDelayScoreRecord', 'post', config),

            initReportData: config => createAPI('/scoreManage/register/delayScore/initReportData', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManage/register/delayScore/loadCourseCombo', 'post', config),

            queryReportInfo: config => createAPI('/scoreManage/register/delayScore/queryReportInfo', 'post', config),

            exportReportInfo: config => createAPI('/scoreManage/register/delayScore/exportReportInfo', 'post', config),

            printReportInfo: config => createAPI('/scoreManage/register/delayScore/printReportInfo', 'post', config),
        },
        //补考成绩登记
        resitScore: {
            initData: config => createAPI('/scoreManage/register/resitScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManage/register/resitScore/queryList', 'post', config),

            loadSubjectInfo: config => createAPI('/scoreManage/register/resitScore/loadSubjectInfo', 'post', config),

            loadStuList: config => createAPI('/scoreManage/register/resitScore/loadStuList', 'post', config),

            saveStuScore: config => createAPI('/scoreManage/register/resitScore/saveStuScore', 'post', config),

            reportExport: config => createAPI('/scoreManage/register/resitScore/reportExport', 'post', config),

            reportPrint: config => createAPI('/scoreManage/register/resitScore/reportPrint', 'post', config),
        },
        //教师成绩登记
        teacherSemesterScore: {
            initData: config => createAPI('/scoreManage/register/teacherSemesterScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManage/register/teacherSemesterScore/queryList', 'post', config),

            loadClassInfo: config => createAPI('/scoreManage/register/teacherSemesterScore/loadClassInfo', 'post', config),
        },
        //大补考成绩登记
        finalResitScore: {
            initData: config => createAPI('/scoreManage/register/finalResitScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManage/register/finalResitScore/queryList', 'post', config),

            loadStuList: config => createAPI('/scoreManage/register/finalResitScore/loadStuList', 'post', config),

            saveStuScore: config => createAPI('/scoreManage/register/finalResitScore/saveStuScore', 'post', config),
        },
        //成绩管理
        scoreManage: {
            initData: config => createAPI('/scoreManage/register/scoreManage/initData', 'post', config),

            queryList: config => createAPI('/scoreManage/register/scoreManage/queryList', 'post', config),

            saveScore: config => createAPI('/scoreManage/register/scoreManage/saveScore', 'post', config),

            changeStuScoreState: config => createAPI('/scoreManage/register/scoreManage/changeStuScoreState', 'post', config),

            queryInvalidScoreList: config => createAPI('/scoreManage/register/scoreManage/queryInvalidScoreList', 'post', config),

            recoveryScore: config => createAPI('/scoreManage/register/scoreManage/recoveryScore', 'post', config),

            loadChangeClassScoreClass: config => createAPI('/scoreManage/register/scoreManage/loadChangeClassScoreClass', 'post', config),

            loadChangeClassScoreCourse: config => createAPI('/scoreManage/register/scoreManage/loadChangeClassScoreCourse', 'post', config),

            queryChangeClassScoreList: config => createAPI('/scoreManage/register/scoreManage/queryChangeClassScoreList', 'post', config),

            changeMultiStuScoreState: config => createAPI('/scoreManage/register/scoreManage/changeMultiStuScoreState', 'post', config),

            queryClassNotRegisterList: config => createAPI('/scoreManage/register/scoreManage/queryClassNotRegisterList', 'post', config),

            loadExportMajorCombo: config => createAPI('/scoreManage/register/scoreManage/loadExportMajorCombo', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManage/register/scoreManage/loadExportClassCombo', 'post', config),

            scoreExport: config => createAPI('/scoreManage/register/scoreManage/scoreExport', 'post', config),

            batchExport: config => createAPI('/scoreManage/register/scoreManage/batchExport', 'post', config),

            collectExport: config => createAPI('/scoreManage/register/scoreManage/collectExport', 'post', config),

            queryStuNotRegisterList: config => createAPI('/scoreManage/register/scoreManage/queryStuNotRegisterList', 'post', config),

            stuNotRegisterExport: config => createAPI('/scoreManage/register/scoreManage/stuNotRegisterExport', 'post', config),

            exportClassNotRegisterList: config => createAPI('/scoreManage/register/scoreManage/exportClassNotRegisterList', 'post', config),

            queryScoreCompletionList: config => createAPI('/scoreManage/register/scoreManage/queryScoreCompletionList', 'post', config),

            completeScore: config => createAPI('/scoreManage/register/scoreManage/completeScore', 'post', config),
        },
        //成绩提交管理
        submitManage: {
            queryList: config => createAPI('/scoreManage/register/submitManage/queryList', 'post', config),

            sendBack: config => createAPI('/scoreManage/register/submitManage/sendBack', 'post', config),

            batchExport: config => createAPI('/scoreManage/register/submitManage/batchExport', 'post', config),
        },
        //结转毕补考成绩登记
        convertResitScore: {
            initCombo: config => createAPI('/scoreManage/register/convertResitScore/initCombo', 'post', config),

            list: config => createAPI('/scoreManage/register/convertResitScore/list', 'post', config),

            save: config => createAPI('/scoreManage/register/convertResitScore/save', 'post', config),
        },
    },
};

export default scoreManage;



// WEBPACK FOOTER //
// ./src/api/modules/scoreManage.js